import React, { Component } from 'react';
import * as Icon from 'react-feather';
import { getSourceTypes } from '../../../services/dataSourceService';
import { SourceTypes } from '../../../constants/DatasourceTypes';
import CustomLoader from '../../common/Loader';
import SourceApi from './SourceApi';
import SourceDatabase from './SourceDb';

class DataSourceSettings extends Component {
	DataSourceTypes = [];

	constructor(props) {
		super(props);

		this.state = {
			DataSource_ID: this.props.location.DataSource_ID ? this.props.location.DataSource_ID : 0,
			DataSource_Type_ID: this.props.location.DataSource_Type_ID ? this.props.location.DataSource_Type_ID : 0,
			loading: false,
		};
	}

	async componentDidMount() {
		this.setState({ loading: true });

		const { data: SourceTypes } = await getSourceTypes();
		this.DataSourceTypes = SourceTypes;

		this.setState({ loading: false });
	}

	handleChange = (input) => {
		let value = input.value;
		value = parseInt(value);
		this.setState({ DataSource_Type_ID: value });
	};

	render() {
		if (this.state.loading) {
			return <CustomLoader loading={this.state.loading} />;
		}

		const { DataSource_Type_ID, DataSource_ID } = this.state;

		return (
			<React.Fragment>
				<header className='page-header page-header-dark bg-gradient-primary-to-secondary pb-10'>
					<div className='container'>
						<div className='page-header-content pt-4'>
							<div className='row align-items-center justify-content-between'>
								<div className='col-auto mt-4'>
									<h1 className='page-header-title'>
										<div className='page-header-icon'>
											<Icon.Tool />
										</div>
										Data Source Settings
									</h1>
								</div>
							</div>
						</div>
					</div>
				</header>

				<div className='container mt-n10'>
					<div className='card'>
						<div className='card-header border-bottom'>
							<div className='row justify-content-center'>
								<label htmlFor='SourceType' className='col-sm-2 col-form-label'>
									Data Source Type
								</label>
								<div className='col-sm-4'>
									<select id='SourceType' className='form-control' value={DataSource_Type_ID} disabled={DataSource_ID !== 0} onChange={(e) => this.handleChange(e.target)}>
										<option value='0'>Select</option>
										{this.DataSourceTypes.map((type) => {
											return (
												<option key={type.DataSource_Type_ID} value={type.DataSource_Type_ID}>
													{type.DataSource_Type_Name}
												</option>
											);
										})}
									</select>
								</div>
							</div>
						</div>

						<div className='card-body'>
							<div className='row justify-content-center'>
								<div className='col-xxl-6 col-xl-8'>
									{DataSource_Type_ID === SourceTypes.Database && <SourceDatabase DataSource_ID={DataSource_ID} />}
									{DataSource_Type_ID === SourceTypes.Web_API && <SourceApi DataSource_ID={DataSource_ID} />}
								</div>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default DataSourceSettings;
